module.exports = __webpack_public_path__ + "media/images/flags/gg-ec48e940536f7bd690f8e567f9a6b9ca.svg";